import { Reducer } from 'redux'
import { initialSessionState } from './initialState'
import {
	SessionActionTypes,
	SessionState,
	MAKE_ADMIN,
	END_SESSION,
	SET_CONNECTED,
	SET_DOMAIN,
	SET_SUBSCRIBED,
	SET_EDITOR,
	SET_USERS,
	SET_VNC_DETAILS,
	SET_PERCENT
} from './types'

const reducer: Reducer<SessionState, SessionActionTypes> = (state: SessionState = initialSessionState, action: SessionActionTypes) => {
	switch (action.type) {
		case MAKE_ADMIN: {
			return {
				...state,
				...{ isAdmin: action.payload }
			}
		}
		case END_SESSION: {
			return {
				...state,
				...{ ended: true }
			}
		}
		case SET_USERS: {
			return {
				...state,
				...{ users: action.payload }
			}
		}
		case SET_CONNECTED: {
			return {
				...state,
				...{ connected: action.payload }
			}
		}
		case SET_DOMAIN: {
			return {
				...state,
				...{ domain: action.payload }
			}
		}
		case SET_SUBSCRIBED: {
			return {
				...state,
				...action.payload
			}
		}
		case SET_EDITOR: {
			return {
				...state,
				...{ fileEditor: action.payload }
			}
		}
		case SET_VNC_DETAILS: {
			return {
				...state,
				...action.payload
			}
		}
		case SET_PERCENT: {
			return {
				...state,
				...action.payload
			}
		}
		default: {
			return state
		}
	}
}

export { reducer as sessionReducer }
